module.exports = __webpack_public_path__ + "img/33398.7fead488.svg";